<template>
    <div>
        <div class="m-portlet m-portlet--full-height ">
            <div class="m-portlet__head">
                <div class="m-portlet__head-tools">
                    <ul class="nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm" role="tablist">
                        <li class="nav-item m-tabs__item">
                            <a class="nav-link m-tabs__link active" data-toggle="tab" :href="'#m_widget5_tab1_content_' + project.id" role="tab">
                                Übersicht
                            </a>
                        </li>
                        <li class="nav-item m-tabs__item">
                            <a class="nav-link m-tabs__link" data-toggle="tab" :href="'#m_widget5_tab2_content_' + project.id" role="tab">
                                Timetracks
                            </a>
                        </li>
                        <li class="nav-item m-tabs__item">
                            <a class="nav-link m-tabs__link" data-toggle="tab" :href="'#m_widget5_tab3_content_' + project.id" role="tab">
                                Finanzen
                            </a>
                        </li>
                        <li class="nav-item m-tabs__item">
                            <a class="nav-link m-tabs__link" data-toggle="tab" :href="'#m_widget5_tab4_content_' + project.id" role="tab">
                                Tasks
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="m-portlet__body">

                <!--begin::Content-->
                <div class="tab-content">
                    <div class="tab-pane active" :id="'m_widget5_tab1_content_' + project.id" aria-expanded="true">

                        <!--begin::m-widget5-->
                        <div class="m-widget5">
                            <div class="m-widget5__item">
                                <div class="m-widget5__content">
                                    <div class="m-widget5__section">
                                        <h4 class="m-widget5__title">{{ project.clientId }} / {{ project.projectNumber }} - <span v-if="project.clientCompany != ''">{{ project.clientCompany }}</span><span v-else>{{ project.clientName }}</span></h4>
                                        <span class="m-widget5__desc">
                                            {{ project.name }}
                                        </span>
                                    </div>
                                </div>
                                <div class="m-widget5__content pl-0">
                                    <div class="m-widget5__section">
                                        <span class="m-widget5__desc pb-2">
                                            <i class="fa fa-cog"></i>&nbsp;&nbsp;{{ project.manager }}
                                        </span><br/>
                                        <span class="m-widget5__desc">
                                            <i class="fa fa-camera"></i>&nbsp;&nbsp;{{ project.photograph }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="m-widget5__item">
                                <h4 class="m-widget5__title">Angebot</h4>
                                <div class="m-widget5__content">
                                    <div class="m-widget5__stats1">
                                        <span class="m-widget5__number">{{ project.sollImages }}</span><br>
                                        <span class="m-widget5__sales">Bilder</span>
                                    </div>
                                    <div class="m-widget5__stats2">
                                        <span class="m-widget5__number">{{ project.sollTimetrackHours }}</span><br>
                                        <span class="m-widget5__votes">Arbeitszeit</span>
                                    </div>
                                </div>
                                <div class="m-widget5__content">
                                    <div class="m-widget5__stats1">
                                        <span class="m-widget5__number">{{ project.sollSum }}</span><br>
                                        <span class="m-widget5__sales">Umsatz</span>
                                    </div>
                                    <div class="m-widget5__stats2">
                                        <span class="m-widget5__number" v-if="parseFloat(project.sollGewinn) > 0" style="color:#34bfa3 !important;">{{ project.sollGewinn }}</span>
                                        <span class="m-widget5__number" v-else style="color:#f4516c !important;">{{ project.sollGewinn }}</span><br>
                                        <span class="m-widget5__votes">Gewinn</span>
                                    </div>
                                </div>
                            </div>

                            <div class="m-widget5__item">
                                <h4 class="m-widget5__title">Ergebnis</h4>
                                <div class="m-widget5__content">
                                    <div class="m-widget5__stats1">
                                        <span class="m-widget5__number">{{ project.images }}</span><br>
                                        <span class="m-widget5__sales">Bilder</span>
                                    </div>
                                    <div class="m-widget5__stats2">
                                        <span class="m-widget5__number">{{ project.timetrackHours }}</span><br>
                                        <span class="m-widget5__votes">Arbeitszeit</span>
                                    </div>
                                </div>
                                <div class="m-widget5__content">
                                    <div class="m-widget5__stats1">
                                        <span class="m-widget5__number">{{ project.sum }}</span><br>
                                        <span class="m-widget5__sales">Umsatz</span>
                                    </div>
                                    <div class="m-widget5__stats2">
                                        <span class="m-widget5__number" v-if="parseFloat(project.gewinn) > 0" style="color:#34bfa3 !important;">{{ project.gewinn }}</span>
                                        <span class="m-widget5__number" v-else style="color:#f4516c !important;">{{ project.gewinn }}</span><br>
                                        <span class="m-widget5__votes">Gewinn</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--end::m-widget5-->
                    </div>
                    <div class="tab-pane" :id="'m_widget5_tab2_content_' + project.id" aria-expanded="false">

                        <!--begin::m-widget5-->
                        <div class="m-widget5">
                            <div class="m-widget5__item" v-for="employee in project.timetrackEmployeeArr" :key="employee.id">
                                <div class="m-widget5__content">
                                    <div class="m-widget5__section">
                                        <h4 class="m-widget5__title">
                                            {{ employee.name }}
                                        </h4>
                                        <span class="m-widget5__desc">
                                            <b>{{ employee.category }}:</b> {{ employee.note }}
                                        </span>
                                    </div>
                                </div>
                                <div class="m-widget5__content">
                                    <div class="m-widget5__stats2">
                                        <span class="m-widget5__number">{{ employee.hoursTrackt }}</span><br>
                                        <span class="m-widget5__votes">Zeit</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--end::m-widget5-->
                    </div>
                    <div class="tab-pane" :id="'m_widget5_tab3_content_' + project.id" aria-expanded="false">

                        <!--begin::m-widget5-->
                        <div class="m-widget5">
                            <div class="m-widget5__item" v-if="project.umsatzNachBild > 0">
                                <div class="m-widget5__content">
                                    <div class="m-widget5__section">
                                        <h4 class="m-widget5__title">
                                            Umsatz Bilder
                                        </h4>
                                        <span class="m-widget5__desc">Alle Umsätze aus den Tasks Bilder</span>
                                    </div>
                                </div>
                                <div class="m-widget5__content">
                                    <div class="m-widget5__stats2" style="width:100%; display:block;">
                                        <span class="m-widget5__number m--font-success">{{ project.umsatzNachBild }}</span><br>
                                        <span class="m-widget5__votes">Bilder Tasks Umsätze</span>
                                    </div>
                                </div>
                            </div>
                            <div class="m-widget5__item" v-if="project.umsatzNachService > 0">
                                <div class="m-widget5__content">
                                    <div class="m-widget5__section">
                                        <h4 class="m-widget5__title">
                                            Umsatz Services
                                        </h4>
                                        <span class="m-widget5__desc">Alle Umsätze aus den Tasks Services</span>
                                    </div>
                                </div>
                                <div class="m-widget5__content">
                                    <div class="m-widget5__stats2" style="width:100%; display:block;">
                                        <span class="m-widget5__number m--font-success">{{ project.umsatzNachService }}</span><br>
                                        <span class="m-widget5__votes">Service Tasks Umsätze</span>
                                    </div>
                                </div>
                            </div>
                            <div class="m-widget5__item" v-if="project.umsatzNachMontage > 0">
                                <div class="m-widget5__content">
                                    <div class="m-widget5__section">
                                        <h4 class="m-widget5__title">
                                            Umsatz Montagen
                                        </h4>
                                        <span class="m-widget5__desc">Alle Umsätze aus den Tasks Montagen</span>
                                    </div>
                                </div>
                                <div class="m-widget5__content">
                                    <div class="m-widget5__stats2" style="width:100%; display:block;">
                                        <span class="m-widget5__number m--font-success">{{ project.umsatzNachMontage }}</span><br>
                                        <span class="m-widget5__votes">Montage Tasks Umsätze</span>
                                    </div>
                                </div>
                            </div>


                            <div class="m-widget5__item" v-for="employee in project.timetrackEmployeeSumArr" :key="employee.id">
                                <div class="m-widget5__content">
                                    <div class="m-widget5__section">
                                        <h4 class="m-widget5__title">
                                            {{ employee.name }}
                                        </h4>
                                        <span class="m-widget5__desc">
                                            Kosten des Mitarbeiters anhand der Stunden
                                        </span>
                                    </div>
                                </div>
                                <div class="m-widget5__content">
                                    <div class="m-widget5__stats2"  style="width:100%; display:block;">
                                        <span class="m-widget5__number m--font-danger">{{ employee.costs }}</span><br>
                                        <span class="m-widget5__votes">Mitarbeiterkosten</span>
                                    </div>
                                </div>
                            </div>
                            <div class="m-widget5__item">
                                <div class="m-widget5__content">
                                    <div class="m-widget5__section">
                                        <h4 class="m-widget5__title">
                                            Dienstleister
                                        </h4>
                                        <span class="m-widget5__desc">
                                            Kosten des Dienstleisters Bildanzahl * Preis pro Bild
                                        </span>
                                    </div>
                                </div>
                                <div class="m-widget5__content">
                                    <div class="m-widget5__stats2" style="width:100%; display:block;">
                                        <span class="m-widget5__number m--font-danger">{{ project.serviceSum }}</span><br>
                                        <span class="m-widget5__votes">Dienstleisterkosten</span>
                                    </div>
                                </div>
                            </div>
                            <div class="m-widget5__item">
                                <div class="m-widget5__content">
                                    <div class="m-widget5__section">
                                        <h4 class="m-widget5__title">
                                            Billanz
                                        </h4>
                                        <span class="m-widget5__desc">
                                            Alle Einnahmen und Ausgaben gegengerechnet
                                        </span>
                                    </div>
                                </div>
                                <div class="m-widget5__content">
                                    <div class="m-widget5__stats2" style="width:100%; display:block;">
                                        <span class="m-widget5__number m--font-danger">{{ project.gewinn }}</span><br>
                                        <span class="m-widget5__votes">Gewinn</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--end::m-widget5-->
                    </div>

                    <div class="tab-pane" :id="'m_widget5_tab4_content_' + project.id" aria-expanded="false">

                        <!--begin::m-widget5-->
                        <div class="m-widget5">
                            <div class="m-widget5__item" v-for="task in project.tasks">
                                <div class="m-widget5__content">
                                    <div class="m-widget5__section">
                                        <h4 class="m-widget5__title">
                                            {{ task.position }} - {{ task.type }}
                                        </h4>
                                        <span class="m-widget5__desc">{{ task.description }}</span>
                                    </div>
                                </div>
                                <div class="m-widget5__content">
                                    <div class="m-widget5__stats2" style="width:100%; display:block;">
                                        <span class="m-widget5__number">{{ task.price }}€</span><br>
                                        <span class="m-widget5__votes">{{ task.quantity }}&nbsp;{{ task.type }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--end::Content-->
            </div>
        </div>
    </div>
</template>
<script>
    export default {

        props:{
            project: Object,
        },
    }
</script>
